export default {
  root: {
    borderRadius: 20,
  },
  containedPrimary: {
    color: '#000000',
    '&:hover': {
      backgroundColor: '#dddddd',
    },
  },
  outlinedPrimary: {
    backgroundColor: 'Transparent',
    borderColor: '#ffffff',
    borderWidth: '1px',
  },
  containedSecondary: {},
  label: {
    fontSize: '16px',
  },
  textSecondary: {},
  contained: {
    '&$disabled': {
      backgroundColor: '#F5F5F5',
      color: '#cccccc',
    },
  },
};
